import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export const WarningImageSection = () => {
  return <section className="py-20 bg-[#050505] relative overflow-hidden" data-id="element-3105" data-mp="11nxbx9q5u80m">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] opacity-30 pointer-events-none" data-id="element-3106" data-mp="1gca92a0zhwwp" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-3107" data-mp="1pbf7lgcjpq8v">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-3108" data-mp="1kdvske80x9fv">
          {/* Forensic Frame */}
          <div className="relative p-2 border border-[#FF0000]/30 bg-[#0a0a0a]" data-id="element-3109" data-mp="3w3pr680bea1o">
            {/* Corner Markers */}
            <div className="absolute -top-1 -left-1 w-6 h-6 border-t-2 border-l-2 border-[#FF0000] z-20" data-id="element-3110" data-mp="29v2plop3dnd8" />
            <div className="absolute -top-1 -right-1 w-6 h-6 border-t-2 border-r-2 border-[#FF0000] z-20" data-id="element-3111" data-mp="2dwo75nckmptr" />
            <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-2 border-l-2 border-[#FF0000] z-20" data-id="element-3112" data-mp="2itxxr6bp57j6" />
            <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-2 border-r-2 border-[#FF0000] z-20" data-id="element-3113" data-mp="2nn0v7pjlh14n" />

            <div className="relative overflow-hidden rounded-lg" data-id="element-3114" data-mp="2smn5pr81g39r">
              <img src="https://cdn.magicpatterns.com/uploads/xsZMS2rh9Tpof42GsoB2Lg/file_000000002864720aa5f3e466fc426e65.png" alt="Red warning flag on metallic surface with dramatic lighting and energy trails - symbolic representation of relationship red flags and danger signals" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700" loading="lazy" decoding="async" data-id="element-3115" data-mp="2xikijnk3erhs" />

              {/* Pulsing Alert Indicator */}
              <div className="absolute top-4 left-4 flex items-center gap-2 bg-black/70 border border-[#FF0000]/50 px-3 py-1" data-id="element-3116" data-mp="2fj1bzzagflln">
                <span className="w-2 h-2 bg-[#FF0000] rounded-full animate-pulse" data-id="element-3117" data-mp="2oief8a7zjdxx" />
                <span className="text-[#FF0000] text-xs font-mono tracking-wider uppercase" data-id="element-3118" data-mp="2jj1qtl1gtyt8">
                  Warning Detected
                </span>
              </div>
            </div>
          </div>

          {/* Glow Effect */}
          <div className="absolute -inset-4 bg-[#FF0000]/5 blur-3xl -z-10 rounded-full" data-id="element-3119" data-mp="2tfwqi79h6593" />
        </motion.div>
      </div>
    </section>;
};